<footer class="footer bg-secondary pt-2 pb-2">
    <div class="container-fluid pb-1 pb-md-0 px-md-5">
      <div
        class="bg-dark rounded-5 position-relative overflow-hidden w-100 py-5 px-3 px-sm-4 px-xl-5 mx-auto"
        style="max-width: 1660px"
        data-bs-theme="dark"
      >
        <div
          class="position-absolute top-50 start-50 translate-middle"
          style="width: 1664px"
        >
          <img src="assets/img/landing/web-studio/footer-wave.png" alt="Wave" />
        </div>
        <div class="container position-relative z-2 pt-md-3 pt-lg-4 pt-xl-5 pb-2">
          <div class="row pb-2">
            <div class="col-lg-4 col-xxl-3 pb-2 pb-lg-0 mb-4 mb-lg-0">
              <div class="navbar-brand text-light py-0 me-0 pb-1 mb-3">
                <span class="text-primary flex-shrink-0 me-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="256" height="74" viewBox="0 0 256 74" fill="none" style="width: 130px; height: auto;"><path d="M69.1501 69.79H14.2601C6.71009 69.79 0.590088 63.67 0.590088 56.12V17.46C0.590088 9.91004 6.71009 3.79004 14.2601 3.79004H69.1501C76.7001 3.79004 82.8201 9.91004 82.8201 17.46V56.12C82.8201 63.67 76.7001 69.79 69.1501 69.79Z" fill="#438C74"></path><path d="M32.5401 38.7901C28.5401 34.7801 24.5801 30.8201 20.5001 26.7401C20.5001 27.1001 20.5001 27.3301 20.5001 27.5601C20.5001 37.8601 20.5001 48.1601 20.5001 58.4601C20.5001 59.3001 20.5001 59.3101 19.6701 59.3101C17.6701 59.3101 15.6601 59.3001 13.6601 59.3201C13.1801 59.3301 12.9801 59.2301 12.9901 58.6901C13.0101 51.1401 13.0101 43.5901 13.0101 36.0301C13.0101 29.0301 13.0001 22.0401 13.0001 15.0401C13.0001 14.3101 13.0001 14.3101 13.7201 14.3101C15.2201 14.3101 16.7301 14.2901 18.2301 14.3301C18.5201 14.3401 18.8801 14.4801 19.0901 14.6901C23.3801 18.9501 27.6601 23.2301 31.9301 27.5101C32.1401 27.7201 32.2801 27.9901 32.4501 28.2301C32.5501 28.2301 32.6501 28.2301 32.7501 28.2301C32.8701 28.0401 32.9601 27.8201 33.1101 27.6601C37.4201 23.3401 41.7501 19.0301 46.0501 14.7001C46.3401 14.4101 46.6201 14.3101 47.0201 14.3001C51.6301 14.1701 55.9401 15.2101 59.8401 17.6901C65.3901 21.2201 68.8401 26.2301 70.0201 32.7101C71.1101 38.7001 69.9401 44.3001 66.4501 49.2901C62.0001 55.6601 55.7701 58.9101 48.0101 59.0201C40.5501 59.1201 33.0901 59.0401 25.6301 59.0401C25.4501 59.0401 25.2701 59.0301 25.0301 59.0101C25.0201 58.8001 25.0001 58.6201 25.0001 58.4401C25.0001 56.2901 24.9801 54.1301 25.0201 51.9801C25.0201 51.6901 25.1901 51.3301 25.4001 51.1301C31.5701 45.2901 37.7601 39.4701 43.9501 33.6501C45.3301 32.3501 46.7101 31.0601 48.1801 29.8301C43.9001 37.0201 39.6301 44.2101 35.2801 51.5101C35.6201 51.5101 35.8201 51.5101 36.0101 51.5101C40.0701 51.5101 44.1401 51.5101 48.2001 51.5101C55.0901 51.5101 61.3301 46.3001 62.5801 39.5301C64.0501 31.5401 59.1801 24.0501 51.3101 22.2001C49.6001 21.8001 49.6101 21.8001 48.3801 23.0301C43.2301 28.1701 38.0801 33.3101 32.9401 38.4501C32.8501 38.5201 32.7301 38.6201 32.5401 38.7901Z" fill="white"></path><path d="M94.185 59.6389V55.7584L117.986 20.2299H93.9263V15.487H124.367V19.3675L100.566 54.896H124.626V59.6389H94.185ZM168.772 37.563C168.772 42.2196 167.931 46.2439 166.25 49.6357C164.568 53.0276 162.262 55.6434 159.33 57.4831C156.398 59.3227 153.049 60.2426 149.283 60.2426C145.518 60.2426 142.169 59.3227 139.237 57.4831C136.305 55.6434 133.998 53.0276 132.317 49.6357C130.635 46.2439 129.794 42.2196 129.794 37.563C129.794 32.9063 130.635 28.882 132.317 25.4902C133.998 22.0983 136.305 19.4825 139.237 17.6428C142.169 15.8032 145.518 14.8833 149.283 14.8833C153.049 14.8833 156.398 15.8032 159.33 17.6428C162.262 19.4825 164.568 22.0983 166.25 25.4902C167.931 28.882 168.772 32.9063 168.772 37.563ZM163.598 37.563C163.598 33.7399 162.959 30.5133 161.679 27.8832C160.415 25.253 158.697 23.2624 156.527 21.9114C154.371 20.5604 151.957 19.8849 149.283 19.8849C146.61 19.8849 144.188 20.5604 142.018 21.9114C139.862 23.2624 138.145 25.253 136.866 27.8832C135.601 30.5133 134.968 33.7399 134.968 37.563C134.968 41.386 135.601 44.6126 136.866 47.2427C138.145 49.8729 139.862 51.8635 142.018 53.2145C144.188 54.5655 146.61 55.241 149.283 55.241C151.957 55.241 154.371 54.5655 156.527 53.2145C158.697 51.8635 160.415 49.8729 161.679 47.2427C162.959 44.6126 163.598 41.386 163.598 37.563ZM212.773 15.487V59.6389H207.599L183.54 24.9728H183.109V59.6389H177.762V15.487H182.936L207.082 50.2394H207.513V15.487H212.773ZM223.472 59.6389V15.487H250.118V20.2299H228.818V35.1484H248.738V39.8913H228.818V54.896H250.463V59.6389H223.472Z" fill="#448c74"></path></svg>
                </span>
              </div>
              <p class="text-body fs-sm mb-4">
                Stay updated with MDzone! 
              </p>
              <div class="input-group input-group-sm rounded-pill">
                <input
                  class="form-control"
                  type="text"
                  placeholder="Email address"
                />
                <button class="btn btn-primary rounded-pill" type="button">
                  Subscribe
                </button>
              </div>
            </div>
            <div class="col-sm-4 col-lg-3 col-xl-3 offset-lg-0 offset-xl-1 offset-xxl-2 mb-4 mb-sm-0 mb-4 mb-sm-0">
              <h6 class="fw-bold mb-3">Treatment</h6>
              <ul class="nav flex-column fs-sm">
                  <li class="nav-item">
                    <a routerLink="/weight" routerLinkActive="router-link-active" 
                      class="nav-link fw-normal px-0 py-1"
                      >Weight Management Program</a
                    >
                  </li>
                  <li class="nav-item">
                    <a href="javascript:void(0);" title="Coming Soon" routerLinkActive="router-link-active" 
                      class="nav-link fw-normal px-0 py-1"
                      >Testosterone Therapy</a>
                  </li>
                  <li class="nav-item">
                    <a href="javascript:void(0);" title="Coming Soon" routerLinkActive="router-link-active" 
                      class="nav-link fw-normal px-0 py-1"
                      >Insomnia Therapy</a>
                  </li>
                  <li class="nav-item">
                    <a href="javascript:void(0);" title="Coming Soon" routerLinkActive="router-link-active" 
                      class="nav-link fw-normal px-0 py-1"
                      >Erectile Dysfunction Therapy</a>
                  </li>
              </ul>
            </div>
            <!-- <div class="col-sm-4 col-lg-2 mb-4 mb-sm-0">
              <h6 class="fw-bold">Learn More </h6>
              <ul class="nav flex-column fs-sm">
                <li class="nav-item">
                  <a routerLink="/simple-access" routerLinkActive="router-link-active" 
                    class="nav-link fw-normal px-0 py-1"
                    >Simple Steps</a
                  >
                </li>
                  <li class="nav-item">
                    <a routerLink="/provider" routerLinkActive="router-link-active" 
                      class="nav-link fw-normal px-0 py-1"
                      >Our Provider</a
                    >
                  </li>
              </ul>
            </div> -->
            <div class="col-sm-4 col-lg-2 mb-4 mb-sm-0">
            <h6 class="fw-bold">Learn More</h6>
            <ul class="nav flex-column fs-sm">
                <li class="nav-item">
                  <a routerLink="/contacts" routerLinkActive="router-link-active" 
                    class="nav-link fw-normal px-0 py-1"
                    >Contact </a
                  >
                </li>
                <li class="nav-item">
                  <a routerLink="/blogs" routerLinkActive="router-link-active" 
                    class="nav-link fw-normal px-0 py-1"
                    >Blogs</a
                  >
                </li>
                <li class="nav-item">
                  <a routerLink="/values" routerLinkActive="router-link-active" 
                    class="nav-link fw-normal px-0 py-1"
                    >Values</a
                  >
                </li>
            </ul>
          </div>
            <div class="col-sm-4 col-lg-3 col-xl-2">
              <h6 class="fw-bold">Contact us</h6>
              <ul class="nav flex-column fs-sm">
                <li class="nav-item">
                  <a
                    class="nav-link fw-normal px-0 py-1"
                    href="mailto:info&#64;mdzone.health"
                    >info&#64;mdzone.health</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link fw-normal px-0 py-1" href="tel:+1737-243-9631"
                    >737-243-9631</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="d-sm-flex align-items-end justify-content-center border-bottom mt-2 mt-sm-1 pt-4 pt-sm-5">
            <p class="font-14px">
              MDZone Health Inc. ™ is an online telehealth platform that collaborates with phyicians using the engagement platform. We offer medical and pharmacy services through independent services. The information intended on this website is intended for informational purposes only. If you have any health related concerns please consult your physician.
            </p>
          </div>
          <div class="d-sm-flex align-items-end justify-content-center border-bottom mt-2 mt-sm-1 pt-3 pt-sm-3">
            <nav class="nav d-flex justify-content-center mb-3 mb-sm-4">
              <a
                class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px"
                routerLink="/privacy-policy"
                >Privacy Policy</a>
              <a
                class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px"
                routerLink="/ccpa"
                >CCPA</a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" routerLink="/NoticeOfPrivacyPractices">
                Notice of Privacy Practices
              </a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" routerLink="/imsi">
                Important Safety Information
              </a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" routerLink="/MedicalConsent">
                Medical Consent
              </a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" routerLink="/bor">
                Bill of Rights
              </a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" routerLink="/terms-service">
                Terms of Service
              </a>
              <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-3 font-10px" href="../../../../sitemap.xml">
                Sitemap
              </a>
              <!-- <a class="nav-link text-body-secondary fw-normal ps-0 pe-2 py-2 me-sm-3 font-10px" routerLink="/CookiePreferences">
                Cookie Preferences
              </a> -->
            </nav>
        </div>
          <!-- <div
            class="d-sm-flex align-items-center justify-content-between pt-4 pt-md-2 mt-2 mt-md-0 mt-lg-2 mt-xl-2"
          >
            <div class="d-flex justify-content-center order-sm-2 me-md-n2">
              <a
                class="btn btn-icon btn-sm btn-secondary btn-instagram rounded-circle mx-2"
                routerLink="javascript:void(0);"
                aria-label="Instagram"
              >
                <i class="ai-instagram"></i>
              </a>
              <a
                class="btn btn-icon btn-sm btn-secondary btn-facebook rounded-circle mx-2"
                routerLink="javascript:void(0);"
                aria-label="Facebook"
              >
                <i class="ai-facebook"></i>
              </a>
              <a
                class="btn btn-icon btn-sm btn-secondary btn-linkedin rounded-circle mx-2"
                routerLink="javascript:void(0);"
                aria-label="LinkedIn"
              >
                <i class="ai-linkedin"></i>
              </a>
            </div>
            <p
              class="nav fs-sm order-sm-1 text-center text-sm-start pt-4 pt-sm-0 mb-0 me-4"
            >
              <span class="text-body-secondary"
                >&copy; All rights reserved. Made by</span
              >
              <a
                class="nav-link fw-normal p-0 ms-1"
                target="_blank"
                rel="noopener"
                >Premier Solutions</a
              >
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </footer>
  